import styles from './ActionsBg.module.css';

export function ActionsBg() {
  return (
    <div className={styles.root}>
      <div className={styles.bg} />
    </div>
  );
}
